<template>
  <div class='text-center m-4'>
    <div class="spinner-border" role="status">
      <span class="sr-only">.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<style scoped>

</style>
